import keywordsData from "@data/tables/constants/keywords.json";

export const keywords = keywordsData as { name: string; list: string[] };
